import React, { useMemo, useState, useEffect } from "react";
import { AuthRoutes } from "../../constants/Constants";
import {DefaultButton, PrimaryButton, TextField } from "@fluentui/react";
import CustomBreadCrumb from "../../components/CustomBreadCrumb";
import { QueryClient, QueryClientProvider, useQuery } from 'react-query'
import { getViewAnnotationDetail } from "../../service/MasterService";
import AnnotationColorBox from "./AnnotationColorBox";
import tableStyles from '../../components/Table/Table';
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import AddButton from "../../components/AddButton";
import DataTable from "../../components/DataTable/DataTable";

const queryClient = new QueryClient();

const ViewAnnotation = () => {
  const {state} = useLocation();
  const navigate = useNavigate();
    const [loading,setLoading] = useState(false);
    const [viewAnnotationDetail, setViewAnnotationDetail] = useState([]);
    const [annotationModalityList, setAnnotationModalityList] = useState([]);
    const [viewChildAnnotationDetail, setViewChildAnnotationDetail] = useState([]);

    const handleUserClick = (cell) => {
      
    }

    const breadCrumbItems = [
        {
          text: "Annotation",
          key: "annotation",
          href: AuthRoutes.ANNOTATION,
        },
        {
          text: state.annotation_name,
          key: "annotation-name",
        },
    ];

    useEffect(() =>{
      fetchAnnotationDetail();
    }, [] );

    const fetchAnnotationDetail = async () => {
      setLoading(true);
      let payload = {
        "id":state.annotation_id
      }
      const response = await getViewAnnotationDetail(payload);
      if (response.status === 200 && response.data.result === "SUCCESS") {   
        const parentAnnotation = response.data.data.viewAnnotationOut.parentAnnotation;
        const childAnnotation = response.data.data.viewAnnotationOut.childAnnotationList;
        setViewChildAnnotationDetail(childAnnotation);
        setAnnotationModalityList(parentAnnotation.modalityList.join(", "));
        setViewAnnotationDetail(parentAnnotation);
        setLoading(false);
       }
    }

    const childAnnotationFunc = (viewChildAnnotationDetail) =>{
      var list2 = viewChildAnnotationDetail;
      var list = [];
      list2.forEach(element => {
        list.push({
          "id":element.id,
          "name":element.name,
          "color": <AnnotationColorBox color={element.color}/>,
          "modality":element.modalityList.join(", "),
          "action":element.active ? "Active" : "Inactive"
        });
      });
      const data = {
        results: list,
        count: list.length
      };
      return data;
    };

    const handleCancel = () => {
      navigate(AuthRoutes.ANNOTATION);
    };

    const handleEdit = () =>{
      // console.log("navigate to edit page with data");
    }

    const columns = useMemo(
      () => [
        {
          Header: "Annotation Name",
          key:"annotation_name",
          accessor: "name",
          className: "ms-Grid-col ms-sm6 ms-md4 ms-lg1",
          classChildName: "ms-Grid-col ms-sm6 ms-md4 ms-lg1 break-word cursor-pointer",
          sorting:true,
          Cell: ({ cell }) => <><p className="user-view-link" onClick={() => handleUserClick(cell)}>{cell.row.values.name}</p></>,
        },
        {
            Header: "Annotation Color",
            key:"color",
            accessor: "color",
            className: "ms-Grid-col ms-sm6 ms-md4 ms-lg1 blue",
          classChildName: "ms-Grid-col ms-sm6 ms-md4 ms-lg1",
        },
        {
          Header: "Modality",
          accessor: "modality",
          className: "ms-Grid-col ms-sm6 ms-md4 ms-lg1 blue",
          classChildName: "ms-Grid-col ms-sm6 ms-md4 ms-lg1",
      },
      {
        Header: "Action",
        accessor: "action",
        className: "ms-Grid-col ms-sm6 ms-md4 ms-lg1 blue",
        classChildName: "ms-Grid-col ms-sm6 ms-md4 ms-lg1",
    }
      ]
    );
     
    return (
        <>
            <div id="add-container" style={{ padding: "20px 20px" }}>
                <div className="breadCrumb">
                    <CustomBreadCrumb items={breadCrumbItems} />
                </div>
            
            <div>
            <table className={tableStyles.tableWidth} style={{ marginTop:"3%"}}>
              <thead>
                <tr>
                  <th style={{width:"25%"}}>Annotation Color</th>
                  <th>Action</th>
                  <th>Modality</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <AnnotationColorBox color={viewAnnotationDetail.color} />
                  </td>
                  <td>
                    {viewAnnotationDetail.active?"Active":"Inactive"}
                  </td>
                  <td>{annotationModalityList}</td>
                  <td>
                    <PrimaryButton 
                      text="Edit"
                      style={{ marginRight:"10px" }}
                      onClick = {handleEdit}
                    />
            <DefaultButton 
              text="Cancel"
              style={{
                marginRight:"10px"
              }}
              onClick={handleCancel}
            />
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
            <div id="child_annotation">
            <div className="listPage-headerDiv" style={{marginTop:"5%"}}>
              <p className="listPage-header">Child Annotation</p>
            </div>

            <Link to={AuthRoutes.ADDANNOTATION}>
              <AddButton text="Add Annotation"/>
            </Link>
            <QueryClientProvider client={queryClient}>
            <DataTable 
              fetchFunction={childAnnotationFunc(viewChildAnnotationDetail)} 
              columns={columns} 
            />
          </QueryClientProvider>
              </div>
            </div>
        </>
    );
}

export default ViewAnnotation;